import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Certification = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M4.392 14.054l1.544.893a1 1 0 01.499.866v1.776h1.776c.357 0 .688.19.866.5l.892 1.543 1.543-.893a1.006 1.006 0 011.001 0l1.545.893.891-1.543a1 1 0 01.866-.5h1.776v-1.776a1 1 0 01.499-.866l1.544-.893-.893-1.543a1 1 0 010-1.001l.893-1.543-1.544-.893a1 1 0 01-.499-.866V6.432h-1.776a.998.998 0 01-.866-.5l-.891-1.543-1.545.892a.998.998 0 01-1 0l-1.544-.892-.892 1.543c-.179.309-.509.5-.866.5H6.435v1.776a1 1 0 01-.499.866l-1.544.892.893 1.542c.18.31.18.692 0 1.001l-.893 1.545z",
    key: "k0"
  }), React.createElement("path", {
    d: "M2.06 14.677a.994.994 0 00.465.607l1.91 1.104v2.199a1 1 0 001 1h2.199l1.104 1.91a1.007 1.007 0 00.866.5 1 1 0 00.501-.134l1.908-1.104 1.91 1.104a1.001 1.001 0 001.366-.366l1.103-1.909h2.199a1 1 0 001-1v-2.199l1.91-1.104a1 1 0 00.365-1.366l-1.104-1.909 1.104-1.908a1 1 0 00-.365-1.366l-1.91-1.104v-2.2a1 1 0 00-1-1h-2.199l-1.103-1.909a1.004 1.004 0 00-.607-.466.993.993 0 00-.759.1l-1.91 1.104-1.909-1.104a.998.998 0 00-1.366.365l-1.104 1.91H5.435a1 1 0 00-1 1v2.199l-1.91 1.104a.998.998 0 00-.365 1.367l1.104 1.908-1.104 1.908a.997.997 0 00-.1.759zm3.224-3.168l-.892-1.543 1.544-.893a1 1 0 00.499-.866V6.432h1.776c.357 0 .688-.19.866-.5l.892-1.543 1.544.892a.998.998 0 001 0l1.545-.892.891 1.543a1 1 0 00.866.5h1.776v1.776a1 1 0 00.499.866l1.544.893-.893 1.543a1 1 0 000 1.001l.893 1.543-1.544.893a1 1 0 00-.499.866v1.776h-1.776a.998.998 0 00-.866.5l-.891 1.543-1.545-.893a1 1 0 00-1.001 0l-1.543.893-.892-1.543a1.002 1.002 0 00-.866-.5H6.435v-1.776a1 1 0 00-.499-.866l-1.544-.893.893-1.543a1 1 0 00-.001-1.002z",
    key: "k1"
  }));
});
Certification.displayName = 'Certification';
export var CertificationDimensions = {
  height: 24,
  width: 24
};